import { Route, RouteConfig } from 'vue-router';
import { WmsPageComposer } from '../components/page-composer/page-composer';
import { router } from './router';

export const NZD_URL = 'zdravideti';

export const NZD_ROUTES: RouteConfig[] = [
	{
		path: '/page/nzd-uvod',
		name: 'nzd-uvod',
		meta: { nzdRedirect: '/' },
		props: { pageUrl: 'nzd-uvod' },
		component: WmsPageComposer
	},
	{
		path: '/page/nzd-jak-jsme-pomohli',
		name: 'nzd-jak-jsme-pomohli',
		alias: '/jak-jsme-pomohli',
		meta: { nzdRedirect: '/jak-jsme-pomohli' },
		props: { pageUrl: 'nzd-jak-jsme-pomohli' },
		component: WmsPageComposer
	},
	{
		path: '/page/nzd-jak-pomoci',
		name: 'nzd-jak-pomoci',
		alias: '/jak-pomoci',
		meta: { nzdRedirect: '/jak-pomoci' },
		props: { pageUrl: 'nzd-jak-pomoci' },
		component: WmsPageComposer
	},
	{
		path: '/page/nzd-akce',
		name: 'nzd-akce',
		alias: '/akce',
		meta: { nzdRedirect: '/akce' },
		props: { pageUrl: 'nzd-akce' },
		component: WmsPageComposer
	},
	{
		path: '/page/nzd-ke-stazeni',
		name: 'nzd-ke-stazeni',
		alias: '/ke-stazeni',
		meta: { nzdRedirect: '/ke-stazeni' },
		props: { pageUrl: 'nzd-ke-stazeni' },
		component: WmsPageComposer
	},
	{
		path: '/page/nzd-kontakt',
		name: 'nzd-kontakt',
		alias: '/kontaktujte',
		meta: { nzdRedirect: '/kontaktujte' },
		props: { pageUrl: 'nzd-kontakt' },
		component: WmsPageComposer
	},
];

export function nzdGuard(to: Route, _from: Route, next: Function): boolean {
	if (window.location.href.indexOf(NZD_URL) > -1 && to.meta.nzdRedirect) {
		if (to.meta.nzdRedirect !== to.fullPath) {
			next({ path: to.meta.nzdRedirect, replace: true });
			return true;
		}
	}

	if (window.location.href.indexOf(NZD_URL) === -1 && to.meta.nzdRedirect) {
		next({ path: '/nenalezeno', replace: true });
		return true;
	}

	if (
		window.location.href.indexOf(NZD_URL) > -1 &&
		to.fullPath !== '/' &&
		!to.meta.nzdRedirect
	) {
		const { afterClick } = (router as any).meta;

		// send all other route requets as HTTP GET requests
		if (afterClick) {
			window.location.href = to.fullPath;
		} else {
			window.location.href = `https://www.central-group.cz/nenalezeno.html`;
		}

		return true;
	}

	return false;
}
